// Page Data Postingan
// --------------------------------------------------------

import React, { useState } from "react";
import Title from "../../../components/Title";
import { styled } from "@mui/material/styles";

// Asset
import Button from "../../../components/Button";
import { ReactComponent as BlueThumb } from "../../../assets/icon/icon-blue-thumb.svg";
import { ReactComponent as ShareGray } from "../../../assets/icon/icon-share-gray.svg";
import { ReactComponent as IconComment } from "../../../assets/icon/icon-comment.svg";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  actionPostingan,
  getDetailDataPengguna,
  setActiveStep,
  setValueReason,
} from "../../../store/actions/dataPostingan";
import moment from "moment";
import PopUp from "../../../components/PopUp";
import iconEdit from "../../../assets/icon/icon-edit.png";
import PopUpPenolakan from "../../../components/PopUpPenolakan";

const DetailPostingan = () => {
  const [confDecline, setConfDecline] = useState(false);
  const [popupStatus, setPopupStatus] = useState(false);

  const dispatch = useDispatch();

  const { detailPostingan, setId, valueReason } = useSelector(
    (state) => state.dataPostingan,
    shallowEqual
  );

  return (
    <Container>
      {/* Title */}
      <Title
        title="Postingan"
        withBack
        onBack={() => dispatch(setActiveStep("page"))}
      />

      {/* Image & Post */}
      <RowWrapper>
        <PostPageWrapper>
          <div
            style={{
              height: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "23px",
                fontFamily: "Inter",
                fontWeight: 500,
                fontSize: "15px",
              }}
            >
              <img
                alt="profile-img"
                src={detailPostingan?.post_page?.foto_profile}
                height="52px"
                width="52px"
                style={{
                  height: "52px",
                  width: "52px",
                  borderRadius: "100%",
                }}
              />
              {detailPostingan?.post_page?.full_name}
            </div>
            <div
              style={{
                padding: "10px 10px 0px 10px",
              }}
            >
              <p
                style={{
                  whiteSpace: "pre-wrap",
                  maxWidth: "fit-content",
                  height: "fit-content",
                }}
              >
                {detailPostingan?.post_page?.post_text}
              </p>
            </div>
          </div>
          <div style={{ display: "flex", gap: "5px" }}>
            <Button
              full
              borderRadius="50px"
              color="#FAFAFA"
              border="1px solid #EDEDED"
            >
              <BlueThumb />
              <p style={{ color: "black" }}>
                {detailPostingan?.post_page.total_like}
              </p>
            </Button>
            <Button
              full
              borderRadius="50px"
              color="#FAFAFA"
              border="1px solid #EDEDED"
            >
              <IconComment />
              <p style={{ color: "black" }}>
                {detailPostingan?.post_page.total_comment}
              </p>
            </Button>
            <Button
              full
              borderRadius="50px"
              color="#FAFAFA"
              border="1px solid #EDEDED"
            >
              <ShareGray />
              <p style={{ color: "black" }}>
                {detailPostingan?.post_page.total_like}
              </p>
            </Button>
          </div>
        </PostPageWrapper>
        <ContentWrapper>
          <h3
            style={{
              borderBottom: "1px solid black",
            }}
          >
            Info Laporan
          </h3>
          <div>
            <p
              style={{
                fontWeight: "500",
              }}
            >
              Kategori Laporan :
            </p>
            <p>{detailPostingan?.report[0].category_name || "-"}</p>
          </div>
          <div>
            <p
              style={{
                fontWeight: "500",
              }}
            >
              Isi Laporan :
            </p>
            <p>
              {(detailPostingan?.report &&
                detailPostingan?.report[0].description) ||
                "-"}
            </p>
          </div>
        </ContentWrapper>
      </RowWrapper>

      <RowWrapper>
        {detailPostingan?.image_list?.map((item) => (
          <ContentWrapper>
            <img
              alt="img-post"
              src={item.file_name}
              style={{
                maxHeight: "100%",
                maxWidth: "100%",
                objectFit: "cover",
              }}
            />
          </ContentWrapper>
        ))}
        <ContentWrapper>
          <h3
            style={{
              borderBottom: "1px solid black",
            }}
          >
            Info Pelapor
          </h3>
          <div>
            <p
              style={{
                fontWeight: "500",
              }}
            >
              Nama Pelapor Laporan :
            </p>
            <p>
              {detailPostingan?.report && detailPostingan?.report[0].full_name}
            </p>
          </div>
          <div>
            <p
              style={{
                fontWeight: "500",
              }}
            >
              Tanggal Lapor :
            </p>
            <p>
              {moment(
                detailPostingan?.report && detailPostingan?.report[0].create_at
              ).format("DD MMMM YYYY")}
            </p>
          </div>
        </ContentWrapper>
      </RowWrapper>
      <RowWrapper>
        <Button
          color="#E20000"
          width="50%"
          onClick={() => {
            setConfDecline(true);
          }}
        >
          Nonaktifkan Postingan
        </Button>
        <Button
          color="#039C40"
          width="50%"
          onClick={() => {
            dispatch(
              getDetailDataPengguna(detailPostingan.report[0].id_reporter)
            );
          }}
        >
          Tampilkan Profil Pelapor
        </Button>
      </RowWrapper>

      <PopUp
        open={confDecline}
        type="choice"
        width="350px"
        onClose={() => {
          setConfDecline(false);
          dispatch(actionPostingan(setId, "2"));
        }}
        onClickAction={() => {
          setConfDecline(false);
        }}
        title="Konfirmasi"
        info="Anda yakin ingin menonaktifkan postingan?"
      />

      <PopUpPenolakan
        open={confDecline}
        type="choice"
        width="350px"
        valueInput={valueReason}
        onChange={(e) => dispatch(setValueReason(e.target.value))}
        onClickAction={() => {
          setConfDecline(false);
          dispatch(actionPostingan(detailPostingan?.post_page.post_id, "2"));
        }}
        onClose={() => {
          setConfDecline(false);
        }}
        title="Konfirmasi"
        info="Anda yakin ingin menonaktifkan postingan?"
      />

      <PopUp
        open={popupStatus}
        imgSrc={iconEdit}
        onClose={() => dispatch(setPopupStatus(false))}
        buttonWord="Ok"
        onClickAction={() => dispatch(setPopupStatus(false))}
        title="Postingan Berhasil Dinonaktifkan"
      />
    </Container>
  );
};

const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "20px",
}));

const RowWrapper = styled("div")(() => ({
  display: "flex",
  gap: "20px",
}));

const PostPageWrapper = styled("div")(() => ({
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.1)",
  padding: "15px",
  borderRadius: "10px",
  minHeight: "267px",
  gap: "15px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  width: "100%",
  flexGrow: "1",
  flexBasis: "0",
}));

const ContentWrapper = styled("div")(() => ({
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 3px 10px rgba(0, 0, 0, 0.1)",
  padding: "15px",
  borderRadius: "10px",
  height: "267px",
  gap: "15px",
  display: "flex",
  flexDirection: "column",
  whiteSpace: "nowrap",
  width: "100%",
  flexGrow: "1",
  flexBasis: "0",
}));

export default DetailPostingan;
